async function DeleteFile (fileToDelete) {

    if (true) {

            let response;
            let formData = new FormData();

            formData.append("file", fileToDelete);
            formData.append("folder", "attachments");

            response = await fetch ("https://api.cssi.co/CNF/DeleteFile", {
                method: "POST",
                body: formData})
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);
    }
}
 
export default DeleteFile;